import { FC, useState } from 'react';
import { BranchFocusContext, BranchFocusState } from './BranchFocusContext';
import { useTreeViewContext } from './TreeViewContext';

export const BranchFocusContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { showBranchFocus = false } = useTreeViewContext();
  const [activeBranch, setActiveBranch] = useState<string>('');

  const contextValue: BranchFocusState = {
    activeBranch,
    setActiveBranch,
    showBranchFocus,
  };

  return <BranchFocusContext.Provider value={contextValue}>{children}</BranchFocusContext.Provider>;
};
